import { ChainId, getContractAddress } from '@ballz-app/sdk';

export const getBallzAddressByEnv = () => {
  let displayChainId = ChainId.CRONOS_MAINNET;
  if (process.env.APP_ENV === 'dev' || process.env.APP_ENV === 'stag') {
    displayChainId = ChainId.CRONOS_TESTNET;
  }
  return getContractAddress(ChainId.CRONOS_MAINNET, 'Ballz');
};
